export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.addEventListener(
      'load',
      () => {
        if (reader.result === null) {
          reject(new Error('File is empty'));
          return;
        }
        resolve(reader.result as string);
      },
      false
    );
    reader.addEventListener('error', event => {
      reject(event);
    });
    reader.readAsText(file);
  });
}
